module.exports = __webpack_public_path__ + "img/industry-1.a0fff641.jpg";